import { partnerApi } from '../../lib/api';

const TENANT_PICKER_LIMIT = 200;
const TENANT_PICKER_FIELDS = ['id', 'name', 'externalId'];

// Shares one tenant-picker query key across every tool test panel.
export const tenantPickerQuery = {
  queryKey: ['tenants', { fields: TENANT_PICKER_FIELDS }],
  queryFn: () =>
    partnerApi.getTenants(false, {
      limit: TENANT_PICKER_LIMIT,
      fields: TENANT_PICKER_FIELDS,
      orderBy: 'name' as const,
      orderDirection: 'asc' as const,
    }),
};
